import { defineSlotRecipe } from '@chakra-ui/react';

import { paginationItemBorderRadius, paginationItemSize } from './pagination.kds';

const pageControlStyles = {
  alignItems: 'center',
  bg: 'neutral.0',
  boxSize: paginationItemSize,
  borderRadius: paginationItemBorderRadius,
  color: 'neutral.400',
  cursor: 'pointer',
  display: 'inline-flex',
  flexShrink: 0,
  justifyContent: 'center',
  textStyle: 'default.medium',
  _hover: {
    bg: 'brand.50',
  },
  '&[data-selected]': {
    bg: 'brand.500',
    color: 'neutral.0',
    _hover: {
      bg: 'brand.500',
    },
  },
} as const;

/** KDS Pagination — page controls and navigation triggers; register as `pagination` in `theme/system.ts`. */
export const paginationSlotRecipe = defineSlotRecipe({
  slots: ['root', 'item', 'ellipsis', 'prevTrigger', 'nextTrigger'],
  base: {
    root: {
      display: 'contents',
    },
    item: pageControlStyles,
    ellipsis: {
      ...pageControlStyles,
      cursor: 'default',
      _hover: {
        bg: 'neutral.0',
      },
    },
  },
});
